import { AddEditSupplier as Page } from './AddEditSupplier.main';

export const AddEditSupplier = { Page };
